import { createContext } from "react";

export const CatalogsContext = createContext()